import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=18172f2a&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=18172f2a&prod&lang=scss"
import style1 from "./upload.vue?vue&type=style&index=1&id=18172f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18172f2a",
  null
  
)

export default component.exports